import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'  // 如果不用按需引入，可保留这行
import '../src/assets/css/element-variables.scss';
// 如果你用按需引入（推荐），可以注释上面两行，靠 vite 插件自动处理


import UmyUi from 'umy-ui';
Vue.use(UmyUi);
import 'umy-ui/lib/theme-chalk/index.css';// 引入样式
import {UTableColumn, UTable,UxGrid,UxTableColumn} from 'umy-ui'; // 按需引入组件

Vue.use(UTableColumn);
Vue.use(UTable);
Vue.use(UxGrid);
Vue.use(UxTableColumn);
Vue.use(ElementUI)

Vue.config.productionTip = false
// 全局路由错误处理
import request from '@/request.js'  // 假设你的文件路径是 src/utils/request.js

// 全局挂载到 Vue 原型
Vue.prototype.$request = request

const originalReplace = router.replace
router.replace = function replace(location, onResolve, onReject) {
    if (onResolve || onReject) {
        return originalReplace.call(this, location, onResolve, onReject)
    }
    return originalReplace.call(this, location).catch(err => {
        // 忽略重复导航错误（最常见开发警告）
        if (
            err.name === 'NavigationDuplicated' ||
            (err.message && err.message.includes('Avoided redundant navigation'))
        ) {
            return Promise.resolve(err) // 静默处理
        }
        throw err
    })
}
new Vue({
    router,
    render: h => h(App)
}).$mount('#app')